import { Typography } from "@fullscript/aviary-web";

import { useStoreSettingsQuery } from "./StoreSettings.query.generated";

import * as styles from "./CustomAuthDisclaimer.styles";

interface Props {
  storeSlug: string;
}

export const CustomAuthDisclaimer = ({ storeSlug }: Props) => {
  const { data: storeSettingsData } = useStoreSettingsQuery({
    variables: { storeSlug },
    skip: !storeSlug,
  });

  const disclaimer = storeSettingsData?.viewer?.storefrontConfig?.customAuthDisclaimer;

  if (!disclaimer) {
    return null;
  }

  return (
    <div css={styles.container}>
      <div css={styles.content}>
        <Typography variant="footnote" intention="neutral" colorIntensity="subtle">
          {disclaimer}
        </Typography>
      </div>
    </div>
  );
};
